// extracted by mini-css-extract-plugin
export default {"control":"Product_control__nCTcl","richText":"Product_richText__Vbndc"};